import React from 'react'
import Button from '../../components/ui/Button';
import { checkPermission, getMemberType, hasAnySubscription } from '../../utils/Helper';
import Skeleton from '../../components/ui/Skeleton';
import { HOUSEHOLD_TYPES, PERMISSIONS, USER_ROLE_TYPES } from '../../constants/Constants';
import ProfileImage from '../../components/layouts/ProfileImage';
import callIcon from '../../assets/images/menu/call-icon.svg'
import mailIcon from '../../assets/images/menu/mail-icon.svg'
import moneyBagIcon from '../../assets/images/menu/money-bag-icon.svg'
import user from "../../assets/images/menu/account.svg"
import verticaldotsIcon from "../../assets/images/verticaldots-icon.svg"
import editIcon from "../../assets/images/menu/edit-icon.svg"
import inviteIcon from "../../assets/images/menu/invite-icon.svg"
import binIcon from "../../assets/images/menu/bin-icon.svg"
import justivideLogoIcon from "../../assets/images/Justivide-PrimaryIcon.svg"

const MembersList = ({ hhMembers, profile, loadingMemb, handleSendSendCredential, setInviteMemberForm, setRemoveId, type, onPressEditMember }: any) => {
    return (
        <>
            {
                hhMembers?.loading ?
                    Array.from({ length: 3 })?.map(() => (
                        <div className='household-card'>
                            <div className='household-card-head'>
                                <Skeleton className='skeleton-loader household-u-img' style={{ width: '80px', height: '80px', borderRadius: '12px' }} />
                                <div style={{ marginLeft: '10px', flex: 1 }}>
                                    <Skeleton className='skeleton-loader' style={{ width: '120px', height: '20px' }} />
                                    <Skeleton className='skeleton-loader' style={{ width: '150px', height: '15px', marginTop: '8px' }} />
                                    <Skeleton className='skeleton-loader' style={{ width: '150px', height: '15px', marginTop: '8px' }} />
                                    <Skeleton className='skeleton-loader' style={{ width: '150px', height: '15px', marginTop: '8px' }} />
                                    <Skeleton className='skeleton-loader' style={{ width: '150px', height: '15px', marginTop: '8px' }} />
                                </div>
                            </div>
                            <Skeleton className='skeleton-loader' style={{ width: '140px', height: '40px', marginTop: '16px', borderRadius: '8px' }} />
                        </div>
                    )
                    )
                    :
                    hhMembers?.data?.data?.length > 0 ? hhMembers?.data?.data?.map((member: any, memberIndex: any) => {
                        const userJson = typeof member?.user_json == 'string' ? JSON.parse(member?.user_json) : member?.user_json
                        const memb = type === 'approved' ? member?.user : userJson;
                        const profilePic = (type === 'approved') ? (member?.user?.profile_pic || user) : user;
                        const name = memb?.name;
                        const email = memb?.email;
                        const phoneNumber = (memb?.phone_country_code && memb?.phone_number) ? '+' + memb?.phone_country_code + ' ' + memb?.phone_number : 'N/A';
                        const hoursOfEmployment = memb?.monthly_work_hour || 0;
                        const memberType = getMemberType(member?.member_type);
                        const annualSalary = memb?.income || 'N/A';
                        const isTempUser = memb?.is_temp_user;
                        const showIncome = memb?.show_income_to_other_hh;

                        return (
                            <>
                                <div className='household-card' key={memberIndex}>
                                    <div className='household-card-head'>
                                        <img className='household-u-img' src={profilePic} alt={name} />
                                        <div className='household-card-info'>
                                            <div className='household-header-row'>
                                                <div>
                                                    <div className='household-name'>{name}</div>
                                                    <div className='household-meta'>
                                                        <span className='household-partner'>{memberType}</span>
                                                        {hoursOfEmployment > 0 && (
                                                            <>
                                                                <span className='household-dot'>•</span>
                                                                <span className='household-hours'>{hoursOfEmployment} hrs</span>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                                {
                                                    (type === 'approved' && (hasAnySubscription(profile?.data) || checkPermission(profile?.data?.plan_perms, PERMISSIONS?.ALLOW_INVITE)) && member?.member_type !== HOUSEHOLD_TYPES?.ADMIN && profile?.data?.role_type === USER_ROLE_TYPES?.GROUP_ADMIN) ?
                                                        <div className='remove-card cursor-pointer'>
                                                            <img src={verticaldotsIcon} alt="menu" />
                                                            <div className='remove-card-txt'>
                                                                {isTempUser ? (
                                                                    <div className='remove-card-inner' onClick={() => onPressEditMember(member)}>
                                                                        <img src={editIcon} alt="edit" className='menu-icon' />
                                                                        <span>Edit</span>
                                                                    </div>
                                                                ) : ""}
                                                                {isTempUser ? (
                                                                    <div className='remove-card-inner' data-bs-toggle="modal" data-bs-target="#memberInviteModal" onClick={() => setInviteMemberForm({ member_id: member?.uuid })}>
                                                                        <img src={inviteIcon} alt="invite" className='menu-icon' />
                                                                        <span>Invite</span>
                                                                    </div>
                                                                ) : ''}
                                                                <div className='remove-card-inner' onClick={() => setRemoveId(member?.uuid)}>
                                                                    <img src={binIcon} alt="remove" className='menu-icon' />
                                                                    <span>Remove</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        : ''}
                                            </div>

                                            <div className='household-details'>
                                                {annualSalary !== 'N/A' && showIncome && (
                                                    <div className='household-detail-item'>
                                                        <img src={moneyBagIcon} alt={'money'} className='household-detail-icon' />
                                                        <span>${typeof annualSalary === 'number' ? annualSalary.toLocaleString() : annualSalary}</span>
                                                    </div>
                                                )}
                                                {phoneNumber !== 'N/A' && (
                                                    <div className='household-detail-item'>
                                                        <img src={callIcon} alt={'call'} className='household-detail-icon' />
                                                        <span>{phoneNumber}</span>
                                                    </div>
                                                )}
                                                {email && (
                                                    <div className='household-detail-item'>
                                                        <img src={mailIcon} alt={'call'} className='household-detail-icon' />
                                                        <span>{email}</span>
                                                    </div>
                                                )}
                                                {
                                                    (type == 'pending' && profile?.data?.role_type === USER_ROLE_TYPES?.GROUP_ADMIN) ?
                                                        <Button className='send-credential-btn' loading={loadingMemb?.includes(member?.uuid)} onClick={() => handleSendSendCredential(member?.uuid)}>
                                                            Send Credentials
                                                        </Button> : ""
                                                }
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </>
                        )
                    }) : type === 'approved' ? <>
                        <img
                            src={justivideLogoIcon}
                            alt="Profile"
                            style={{
                                width: '150px',
                                margin: '30px auto 0',
                                display: 'block',
                            }} />
                        <h2 className='form-title'>A household has not yet been added to this account. If you will be joining another user's household, please check your email for an invitation. Otherwise, please click above to create a new household.</h2>
                    </> :
                        <div className='mt-5'>
                            <img className='w-25 rounded-3 mx-auto d-block' src={justivideLogoIcon} alt="" />
                            <p className="form-no-record mt-2">No Record Found</p>
                        </div>
            }
        </>
    )
}

export default MembersList